import GeneralHelper from '../../00_utilities/helpers/GeneralHelper';

class MainNavigation {
    constructor(elem) {
        this.elem = elem;
    }

    init() {
        const primaryMainMenu = document.getElementById('primary-menu');
        const mainNavigation = document.getElementById('main-navigation');
        const breakpoint = 1220;

        primaryMainMenu.addEventListener("mouseover", function (event) {
            if (window.matchMedia(`(min-width: ${breakpoint}px)`).matches) {
                document.body.classList.add('opacity-mode');
            }
        }, false);

        primaryMainMenu.addEventListener("mouseout", function (event) {
            if (window.matchMedia(`(min-width: ${breakpoint}px)`).matches) {
                document.body.classList.remove('opacity-mode');
            }
        }, false);

        mainNavigation.addEventListener("change", function (event) {
            console.log(event.currentTarget.checked);
            document.body.classList.toggle('no-scroll');
        }, false);

        const appHeight = () => {
            const doc = document.documentElement;
            doc.style.setProperty('--app-height', `${window.innerHeight}px`);
        }
        appHeight();
        window.addEventListener('resize', GeneralHelper.throttle(appHeight, 400));
    }
}

export default MainNavigation;
